import { MailSettingsFormWidget } from '../../../features/mail-settings';

export function MailSettingsPage() {
  return <MailSettingsFormWidget />;
}
